<template>
	<div>
		<map-product :data="node" :companyId="companyId" :productId="productId" :projectId="projectId"
			:read_only='read_only' :is_show="is_show"></map-product>
	</div>
</template>

<script>
	import WindowMixin from "@/pages/redirectWindows/Mixins/WindowMixin";
  import MapProduct from "@/components/ProductComponents/MapProduct"
	export default {
		components: {
      MapProduct
		},
    mixins:[WindowMixin],
		data() {
			return {
				node: {},
        companyId: null,
        productId: null,
        projectId: null,
        read_only: false,
        is_show: false,
			}
		},
    beforeMount() {
      console.log(this.$route.query.is_show);
      this.is_show = (this.$route.query.is_show==="true");

    },
    methods: {

		}
	}
</script>

<style>
</style>
